import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { t } from 'utils/translates';

const UserRoomsListItem = props => {
  const hasAuthorLastMessageAvatar =
    props.item.authorLastMessage &&
    (props.auntUserId === props.item.authorLastMessage ||
      props.item.roomType === 2);
  return (
    <Link
      to={`/main/messenger/room/${props.item.roomUuid}`}
      className={classNames('panel-notify', {
        'panel-notify-unread': props.item.countNew > 0
      })}
    >
      <div className="media">
        <div className="media-left media-middle">
          <img
            alt=""
            className="media-object avatar avatar-sm"
            src={props.item.picture}
          />
        </div>
        <div className="media-body media-middle">
          <div className="media-info">
            <span className="media-info-name">{props.item.roomName}</span>{' '}
            <span className="media-info-desc">
              {props.item.createdAtFormatted}
            </span>
          </div>
          <div className="media media_table panel-notify-message">
            {hasAuthorLastMessageAvatar ? (
              <div className="media-left media-middle panel-notify-message-avatar">
                <img
                  alt=""
                  className="media-object avatar panel-notify-message-avatar"
                  src={props.item.authorLastMessageAvatarPath}
                />
              </div>
            ) : null}
            <div
              className={classNames(
                'media-body',
                'media-middle',
                'panel-notify-message-body',
                {
                  'panel-notify-unread': props.item.viewedMembers.length < 2
                }
              )}
            >
              {props.item.shortLastMessage ? (
                props.item.shortLastMessage
              ) : (
                <span className="media-info-desc">{t('Нет сообщений')}</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

UserRoomsListItem.propTypes = {
  auntUserId: PropTypes.number.isRequired,

  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    picture: PropTypes.string.isRequired,
    roomType: PropTypes.number.isRequired,
    roomName: PropTypes.string.isRequired,
    createdAtFormatted: PropTypes.string.isRequired,
    shortLastMessage: PropTypes.string,
    roomUuid: PropTypes.string.isRequired,
    authorLastMessage: PropTypes.number,
    authorLastMessageAvatarPath: PropTypes.string,
    countNew: PropTypes.number.isRequired,
    viewedMembers: PropTypes.arrayOf(PropTypes.shape({})).isRequired
  }).isRequired
};

export default UserRoomsListItem;



// WEBPACK FOOTER //
// ./src/components/Messenger/content/UserRoomsList/UserRoomsListItem.js